export default class AccountSummary {
  constructor() {
    this.account_id = null;
    this.name = null;
    this.account_type_name = null;
    this.account_number = null;
    this.aum = null;
    this.cash = null;
    this.goal_id = null;
    this.goal_name = null;
    this.custodian_name = null;
    this.custodian_id = null;
    this.robo_on_off = null;
    this.min_cash_value = null;
    this.distributionAmount = null;
    this.distributionId = null;
    this.risk_tol_override = null;
    this.risk_tol_override_value = null;
    this.goal_risk_tol_override = null;
    this.goal_risk_tol_override_value = null;
    this.port_override = null;
    this.port_override_id = null;
    this.model_port_name = null;
    this.cl_user_id = null;
    this.amount_available_for_liquidation = null;
    this.dividendSetting = null;
  }
}
